import {
  type Collection,
  User,
  type UserEntity,
  type UserListParams,
} from "~/src/api";

// TODO: replace once BE support for unauthed id filters, this is built for small quantity applications
export const getUsersFromIds = async (
  ids: string[],
  includes: UserListParams["includes"],
  auth?: string | null,
) => {
  if (!ids.length)
    return {
      response: "collection",
      data: [],
      meta: {
        total: ids.length,
        limit: 100,
        offset: 0,
      },
    };

  if (auth) {
    return await User.search(
      {
        ids,
        includes,
        limit: 100,
      },
      auth,
    );
  }

  return {
    type: "collection",
    data: (
      await Promise.all(
        ids.map((id) =>
          User.get(id, includes).catch((res) => {
            console.warn("Failed to fetch user", res);
            return null;
          }),
        ),
      )
    ).filter(onlyTruthys),
    meta: {
      total: ids.length,
      limit: 100,
      offset: 0,
    },
  } as Collection<UserEntity>;
};
